import React from "react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import type { VenueCategory } from "@/hooks/useVenueCategories";

let cache: VenueCategory[] | null = null;
let pending: Promise<VenueCategory[]> | null = null;
const listeners = new Set<(c: VenueCategory[]) => void>();

export const reloadSpotCategories = () => {
  pending = api.get("/spot-categories").then((r) => {
    cache = r.data;
    listeners.forEach((l) => l(r.data));
    return r.data;
  }).finally(() => { pending = null; });
  return pending;
};

export const useSpotCategories = () => {
  const [cats, setCats] = useState<VenueCategory[]>(cache || []);
  useEffect(() => {
    listeners.add(setCats);
    if (!cache && !pending) reloadSpotCategories();
    return () => { listeners.delete(setCats); };
  }, []);
  return cats;
};

export const SpotCat = ({ slug }: { slug: string }) => {
  const { lang } = usePrefs();
  const c = useSpotCategories().find((x) => x.slug === slug);
  return <>{c ? (lang === "ar" ? c.name_ar : c.name_en) : slug}</>;
};
